// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1wx74","fileDisabled":"File_fileDisabled__GMUC_"};